export const encryptionKeys = {
  iv: '9PLQTNVhJcRsbPTU',
  key: 'MKOIJNQASDFVRGHNBHUCFTXDRTTYUA'
};
